<template>
    <!-- 用户昵称 -->
    <span v-if="userInfo.nickname"
        class="f-user-name">
        {{userInfo.nickname}}
    </span>
</template>

<style lang="less"></style>

<script>
import {mapState} from 'vuex';

export default {
    props: {
        userInfo: Object
    },
    computed: {
        ...mapState({
            webPages: state => state.common.webPages
        })
    }
};
</script>
